import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=101f3db4&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=101f3db4&prod&lang=scss&scoped=true&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=101f3db4&prod&lang=css&"
import style2 from "./ForgotPassword.vue?vue&type=style&index=2&id=101f3db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101f3db4",
  null
  
)

export default component.exports